import type { ChatEventMetric } from "./reportChatEvent";

/** Fixed set, so the `outcome` label stays bounded in Mimir. */
export type ChatMessageSendOutcome = "success" | "error" | "contact_ended";

/**
 * Expert send latency: submit to Connect accepting the message, retries and backoff included.
 * Lands in Mimir as `exwo_Duration_seconds{actionName="chat_message_send_latency", hop="frontend_submit_to_accept"}`.
 *
 * - Emitted in seconds: an `ms` unit caps the shared `Duration` buckets at 10 s, which a send that
 *   exhausts its retries can exceed.
 * - Includes offline pauses and background-tab timer throttling, so a long tail can be the
 *   expert's network, not Connect.
 * - Expert sends skip the chat service, so don't merge this with its `exwo_chat_send_hop_latency_milliseconds`.
 */
export function chatMessageSendLatencyMetric({
    durationMs,
    partner,
    outcome,
}: {
    durationMs: number;
    partner: string | undefined;
    outcome: ChatMessageSendOutcome;
}): ChatEventMetric {
    return {
        metrics: [{ name: "Duration", value: Math.round(durationMs) / 1000, unit: "s" }],
        dimensions: {
            actionName: "chat_message_send_latency",
            hop: "frontend_submit_to_accept",
            partner: partner || "unknown",
            outcome,
        },
    };
}
